import serializeParams from './serializeParams';
import { API_URL } from "@core/constants";

class ApiConfig {
    constructor(methods = []) {
        methods.forEach(({ name, url }) => {
            this[name] = `${API_URL}/${url}`;
        });
    }

    get(name, params = {}) {
        return `${this[name]}?${serializeParams(params)}`
    }

    getWithIds(name, ids, params = {}) {
        return `${this[name]}/${ids.join('/')}?${serializeParams(params)}`
    }

    getWithId(name, id, params = {}) {
        return this.getWithIds(name, [id], params);
    }

}

export default new ApiConfig([
    { name: 'countries', url: 'Country' },
    { name: 'byo', url: 'Byo' },
    { name: 'filters', url: 'ByoFilter' },
    { name: 'byo settings', url: 'ByoSettings' },
    { name: 'byo settings get name by id', url: 'ByoSettings/:id/name' },
    { name: 'top trends', url: 'TopTrends' },
    { name: 'copy table', url: 'TopTrendCopyTable' },
    { name: 'food profiles', url: 'FoodProfiles' },
    { name: 'food profile', url: 'FoodProfile' },
    { name: 'food profile lto', url: 'FoodProfileLTO' },
    { name: 'country subscribe', url: 'SubscribeRequest' },
    { name: 'global search', url: 'GlobalSearch' },
    { name: 'restaurant list', url: 'RestaurantList' },
    { name: 'top trends menu examples', url: 'TopTrendMenuExamples' },
    { name: 'byo menu examples', url: 'ByoMenuExamples' },
    { name: 'instant chart', url: 'InstantCharts' },
    { name: 'rtu reports', url: 'RtuReports' },
    { name: 'instant charts get name by id', url: 'InstantCharts/:id/fullName' },
    { name: 'export byo menu examples', url: 'ByoMenuExampleExport' },
    { name: 'export top trends', url: 'TopTrendMainExport' },
    { name: 'export top trends ppt', url: 'TopTrendPptExport' },
    { name: 'export top trends menu examples', url: 'TopTrendMenuExampleExport' },
    { name: 'export menu matrix', url: 'ByoMenuMatrixExport' },
    { name: 'export BYO chart', url: 'ByoTrendChartExport' },
    { name: 'export BYO instant chart', url: 'ByoInstantChartReport' },
    { name: 'export BYO instant chart with flavor', url: 'ByoInstantChartReport/WithFlavor' },
    { name: 'export simple matrix', url: 'ByoSimpleMatrixExport' },
    { name: 'export trend details', url: 'ByoTrendDetailExport' },
    { name: 'export long term report', url: 'ByoLongTermTrendExport' },
    { name: 'export report', url: 'RtuReport' },
    { name: 'export food profile', url: 'FoodProfileReport' },
    { name: 'admin access', url: 'admin/Permission/HasAccess' },
    { name: 'custom restaurant lists', url: 'CustomRestaurantLists' },
    { name: 'request access flavor', url: 'SubscribeRequest/Flavor' },
    { name: 'category report', url: 'CategoryReport' },
    { name: 'category reports', url: 'CategoryReports' },
    { name: 'categories fastest growing', url: 'TopTrendKeywords' },
    { name: 'country states', url: 'Country/GetStates' },
    { name: 'menu examples', url: 'MenuExamples' },
    { name: 'export menu examples', url: 'MenuExamplesExport' },
    { name: 'export time machine report', url: 'Analytics/TimeMachine/AccuracyReport' },
    { name: 'common data', url: 'Common/Get' },
    { name: 'recent searches', url: 'RecentSearches/Get' },
    { name: 'create recent searches', url: 'RecentSearches/Create' },
    { name: 'download instant chart report', url: 'InstantChartReport' },
]);
